export default __webpack_public_path__ + "static/robot-beffa2d7cd45552642ffd092ddf4afcf.png";